
const size = {
	down: {
		xs: `(max-width: 600px)`,
		sm: `(max-width: 960px)`,
		md: `(max-width: 1280px)`,
		lg: `(max-width: 1920px)`,
		xl: `(max-width: 2140px)`,
	},
	up: {
		xs: `(min-width: 0px)`,
		sm: `(min-width: 600px)`,
		md: `(min-width: 960px)`,
		lg: `(min-width: 1280px)`,
		xl: `(min-width: 1920px)`,
	},
	mobileS: '320px',
	mobileM: '375px',
	mobileL: '425px',
	tablet: '768px',
	laptop: '1024px',
	laptopL: '1440px',
	desktop: '2560px'
}

export default size